import { H6, LI, UL } from "../../../../AbstractElements";
import { BlogBy, BlogWithDetailHeading, Hits } from "../../../../Constant";

const ListOfBlogWithoutDetails = () => {
  return (
    <div className="blog-details-main">
      <UL className="blog-social d-flex flex-row simple-list justify-content-center">
        <LI className="digits rounded-0">9 April 2018</LI>
        <LI className="digits rounded-0">{BlogBy} Admin</LI>
        <LI className="digits rounded-0">0 {Hits}</LI>
      </UL>
      <hr />
      <H6 className="blog-bottom-details">{BlogWithDetailHeading}</H6>
    </div>
  );
};

export default ListOfBlogWithoutDetails;
